import * as React from "react";
import FlowLauncher, { FlowLauncherProps } from "./FlowLauncher";
import ModalPopup from "../commons/components/modal/ModalPopup";
import { createRoot } from "react-dom/client";

export interface ModalFlowLauncherProps extends FlowLauncherProps {
  closeUrl: string;
}

export default function ModalFlowLauncher(props: ModalFlowLauncherProps) {
  return (
    <ModalPopup closeModal={() => document.location.assign(props.closeUrl)} fullscreen={true}>
      <FlowLauncher {...props} />
    </ModalPopup>
  );
}

ModalFlowLauncher.loadComponent = (elementId: string, props: ModalFlowLauncherProps) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<ModalFlowLauncher {...props} />);
};
